import React from "react";
import { useFetch } from "@/lib/api";
import {
  PlayCircle, Mic, Image, Video, Megaphone, Calendar, HandHeart, Mail,
  Users, Building2, Sparkles, MessageSquareQuote, Loader2, Clock,
} from "lucide-react";

const CARDS = [
  { key: "sermons", label: "Sermons", icon: PlayCircle },
  { key: "podcasts", label: "Podcasts", icon: Mic },
  { key: "gallery", label: "Gallery Items", icon: Image },
  { key: "videos", label: "Videos", icon: Video },
  { key: "announcements", label: "Announcements", icon: Megaphone },
  { key: "upcoming_events", label: "Published Events", icon: Calendar },
  { key: "new_prayer_requests", label: "New Prayer Requests", icon: HandHeart, highlight: true },
  { key: "unread_messages", label: "Unread Messages", icon: Mail, highlight: true },
  { key: "testimonials", label: "Testimonials", icon: MessageSquareQuote },
  { key: "leadership", label: "Leaders", icon: Users },
  { key: "departments", label: "Departments", icon: Building2 },
  { key: "evangelism_activities", label: "Evangelism", icon: Sparkles },
];

const Overview = () => {
  const { data, loading } = useFetch("/admin/overview");

  if (loading || !data) return <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-brand-orange" /></div>;
  const { counts, recent } = data;

  return (
    <div>
      <h1 className="mb-1 font-display text-2xl font-bold text-navy">Overview</h1>
      <p className="mb-8 text-sm text-muted-foreground">A snapshot of your ministry content and engagement.</p>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
        {CARDS.map((c) => (
          <div key={c.key} data-testid={`stat-${c.key}`} className={`rounded-sm border bg-white p-5 ${c.highlight && counts[c.key] > 0 ? "border-brand-orange" : "border-border"}`}>
            <div className="flex items-center justify-between">
              <span className={`flex h-10 w-10 items-center justify-center rounded-sm ${c.highlight && counts[c.key] > 0 ? "bg-brand-orange text-white" : "bg-navy text-brand-orange"}`}>
                <c.icon className="h-5 w-5" />
              </span>
              <span className="font-display text-3xl font-extrabold text-navy">{counts[c.key] ?? 0}</span>
            </div>
            <p className="mt-3 text-xs font-medium uppercase tracking-wide text-muted-foreground">{c.label}</p>
          </div>
        ))}
      </div>

      <div className="mt-10">
        <h2 className="mb-4 font-display text-lg font-semibold text-navy">Recent Activity</h2>
        <div className="rounded-sm border border-border bg-white">
          {recent.length === 0 ? (
            <p className="px-5 py-10 text-center text-sm text-muted-foreground">No recent activity yet.</p>
          ) : recent.map((r, i) => (
            <div key={i} className="flex items-center justify-between border-b border-border px-5 py-3 last:border-0">
              <div className="flex items-center gap-3">
                <Clock className="h-4 w-4 text-muted-foreground" />
                <div>
                  <p className="text-sm font-medium text-navy">{r.title}</p>
                  <p className="text-xs text-muted-foreground">{r.type}{r.status ? ` · ${r.status}` : ""}</p>
                </div>
              </div>
              <span className="text-xs text-muted-foreground">{r.created_at ? new Date(r.created_at).toLocaleDateString() : ""}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Overview;
